export enum UnicodeEntity {
    Asterisk = '\u002A',
    Bullet = '\u2022',
    Colon = '\u003a',
    Comma = '\u002c',
    Dash = '\u2010',
    Ellipsis = '\u2026',
    ExclamationMark = '\u0021',
    ForwardSlash = '\u002F',
    FullStop = '\u002e',
    GreaterThanSign = '\u003e',
    LeftParenthesis = '\u0028',
    LessThanSign = '\u003c',
    LongDash = '\u2014',
    MiddleDot = '\u00b7',
    MinusSign = '\u2212',
    MultiplicationSign = '\u00d7',
    NewLine = '\u000A',
    NoBreakSpace = '\u00a0',
    Percent = '\u0025',
    Pipe = '\u007C',
    PlusSign = '\u002b',
    RightParenthesis = '\u0029',
    RightwardsArrow = '\u2192',
    Semicolon = '\u003b',
    Space = '\u0020',
}
